/** The background fields that a gallery selection replaces. */
export const BACKGROUND_APPEARANCE_RECORDS = [
  "bgX",
  "bgY",
  "bgScale",
  "bgRotate",
  "bgFlip",
  "customBgs",
  "customBgUploaded",
  "bgPresets",
  "bakedBgs",
  "bgOpacities",
  "bgBrightnesses",
  "logoVariants",
  "textColorLocked",
  "buttonColors",
  "bases",
] as const;

export type BackgroundAppearance = Record<
  (typeof BACKGROUND_APPEARANCE_RECORDS)[number],
  Record<string, unknown>
> & {
  base: string;
  bgBrightness: number;
  bgOpacity: number;
  bgBlurValue: number;
  bakedBgOption: string | null;
};

/** Read a stored background. Missing fields use the editor's initial values. */
export function backgroundAppearanceOf(
  scene: Record<string, unknown> | null
): BackgroundAppearance {
  const records = Object.fromEntries(
    BACKGROUND_APPEARANCE_RECORDS.map((field) => {
      const value = scene?.[field];
      if (value != null && (typeof value !== "object" || Array.isArray(value))) {
        throw new Error(`Invalid background record: ${field}`);
      }
      return [field, value ?? {}];
    })
  ) as Pick<BackgroundAppearance, (typeof BACKGROUND_APPEARANCE_RECORDS)[number]>;
  return {
    ...records,
    base: typeof scene?.base === "string" ? scene.base : "000",
    bgBrightness: typeof scene?.bgBrightness === "number" ? scene.bgBrightness : 100,
    bgOpacity: typeof scene?.bgOpacity === "number" ? scene.bgOpacity : 100,
    bgBlurValue: typeof scene?.bgBlurValue === "number" ? scene.bgBlurValue : 0,
    bakedBgOption: scene?.bakedBgOption == null ? null : String(scene.bakedBgOption),
  };
}
